import React, { useState } from "react";
import "./styles.css";
import { TextField, Grid, Typography, Snackbar, Alert } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Clock from "@mui/icons-material/AccessTime";
import Calendar from "@mui/icons-material/CalendarMonth";
import { InputAdornment } from "@mui/material";
import Button from "../../components/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "react-spring-bottom-sheet/dist/style.css";
import dayjs from "dayjs";

function ReschedulePageFun(props) {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const { closeBtmSheet } = props;
  const [date, setDate] = useState(dayjs());
  const [time, setTime] = useState(dayjs());
  const [issueDescription, setIssueDescription] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const CHARACTER_LIMIT = 250;

  const handleChange = (name) => (event) => {
    setIssueDescription(event.target.value);
  };

  const formatDateTime = (selectedDate, selectedTime) => {
    // Combine the selected date and time using dayjs
    const combinedDateTime = selectedDate
      .hour(selectedTime.hour())
      .minute(selectedTime.minute())
      .second(0);
    
    // Format without timezone conversion
    return combinedDateTime.format('YYYY-MM-DDTHH:mm:ss');
  };

  const handleReschedule = async () => {
    const token = localStorage.getItem("token");
    const currentJobId = jobId || props.jobId || 33;
    
    if (!token) {
      navigate("/login");
      return;
    }

    // Format date and time
    const formattedDateTime = formatDateTime(date, time);

    try {
      const response = await axios.put(
        ` https://jobmanagement-497524552274.us-central1.run.app/api/jobs/${currentJobId}/reschedule?newTime=${formattedDateTime}`,
        {
          description: issueDescription,
          status: "rescheduled",
          ScheduleTime: formattedDateTime
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Job rescheduled successfully", response.data);
      
      setSnackbar({
        open: true,
        message: "Job successfully rescheduled!",
        severity: "success"
      });

      setTimeout(() => {
        navigate(`/CancelledAndRescheduledJobs/${currentJobId}`);
      }, 2000);
      
    } catch (error) {
      console.error("Error rescheduling the job", error);
      
      setSnackbar({
        open: true,
        message: "Failed to reschedule job. Please try again.",
        severity: "error"
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false
    });
  };

  return (
    <Grid pl={3} pr={3} sx={{ display: "flex", flexDirection: "column" }}>
      <Grid pr={1.5} mt={2} pb={3}>
        <ArrowBackIcon
          style={{
            fontSize: 29,
            color: "#0D5C75",
          }}
          onClick={() => {
            navigate(-1);
          }}
        />
      </Grid>
      <Typography
        style={{
          fontSize: "20px",
          textAlign: "left",
          fontWeight: "700",
          letterSpacing: "0.11px",
        }}
      >
        Reschedule Job
      </Typography>
      <Grid sx={{ width: "100%" }}>
        <div id="ques">Select Date*</div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            minDate={dayjs()}
            value={date}
            onChange={(newValue) => {
              setDate(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="MM/DD/YYYY"
                fullWidth="max"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" size="medium">
                      <Calendar
                        style={{
                          fontSize: 29,
                          color: "#0D5C75",
                          borderLeft: "2px solid #3C8C9E",
                          paddingLeft: "10px",
                        }}
                      />
                    </InputAdornment>
                  ),
                  style: {
                    fontSize: 18,
                    width: "100%",
                    border: "1.4px solid #3C8C9E",
                    fontWeight: "500",
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid sx={{ width: "100%" }}>
        <div id="ques">Select Start time preference*</div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker
            value={time}
            onChange={(newValue) => {
              setTime(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth="max"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" size="small">
                      <Clock
                        style={{
                          fontSize: 29,
                          color: "#0D5C75",
                          borderLeft: "2px solid #3C8C9E",
                          paddingLeft: "10px",
                        }}
                      />
                    </InputAdornment>
                  ),
                  style: {
                    fontSize: 18,
                    width: "100%",
                    border: "1.4px solid #3C8C9E",
                    fontWeight: "500",
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid sx={{ width: "100%" }}>
        <div id="ques">Write us more about the issue</div>
        <div
          id="issueTextFieldCls"
          style={{
            width: "100%",
            paddingTop: '10px',
          }}
        >
          <TextField
            className="outlined-multiline-static"
            multiline
            sx={{
              width: "100%",
              paddingTop: "5px",
            }}
            fullWidth="max"
            placeholder="type here..."
            rows={8}
            variant="outlined"
            value={issueDescription}
            onChange={handleChange("name")}
            helperText={`${issueDescription.length}/${CHARACTER_LIMIT}`}
            inputProps={{
              maxLength: CHARACTER_LIMIT,
              style: {
                width: "100%",
              },
            }}
          />
        </div>
      </Grid>
      <Grid mt={2} mb={2} sx={{ display: "flex", justifyContent: "center", position: 'sticky' }}>
        <Button
          name="Confirm Job"
          color="green"
          onClick={handleReschedule}
        />
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity} 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
}

export default ReschedulePageFun;